import React from 'react';

interface IProps {
    time: string;
    timeZone: string;
}

const TimeWithTimezone = (props: IProps) => {
    return (
        <span className='secondary-time-container'>
            {props.time + ' ' + props.timeZone}
        </span>
    );
};

export { TimeWithTimezone };